import { createReducer, on } from '@ngrx/store';
import { fetchStaticListsSuccessAction } from '@app/store/actions/global.actions';
import { StaticList } from '@app/modules/core/interfaces/static-lists';

export type StaticListsState = StaticList[];

export const initialState: StaticListsState = [];

export const staticListsReducer = createReducer(
  initialState,
  on(fetchStaticListsSuccessAction, (_, { staticLists }) => [...staticLists])
);
